"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.border = exports.LabelDialogSectionCategory = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const LabelType_1 = require("../shared/LabelType");
const LabelDialogStateHelpers_1 = require("./LabelDialogStateHelpers");
const LabelDialogStyle_1 = require("./LabelDialogStyle");
const LabelsDialogContexts_1 = require("./LabelsDialogContexts");
const VerticalTabList_1 = require("./VerticalTabList");
function LabelDialogSectionCategory(props) {
    const { initialValues } = (0, LabelsDialogContexts_1.useLabelDialogState)();
    const categories = react_1.default.useMemo(() => (0, LabelDialogStateHelpers_1.getCategoriesFromState)(initialValues), [initialValues]);
    const controls = (0, LabelsDialogContexts_1.useLabelDialogControlsState)();
    const dispatch = (0, LabelsDialogContexts_1.useLabelDialogControlsDispatcher)();
    const items = react_1.default.useMemo(() => [
        { tabContent: { label: catalog_messages_1.Messages.AllLabels() } },
        {
            tabContent: { label: catalog_messages_1.Messages.CustomLabelGridLabelValHeader(), element: react_1.default.createElement(ActiveLabels, null) },
        },
        ...categories.map((category) => ({
            tabContent: { label: category, title: (0, LabelType_1.localizeCategory)(category) },
        })),
    ], [categories]);
    const onActiveIndexChanged = react_1.default.useCallback((index) => {
        if (index === 0) {
            return dispatch({ type: 'SELECT_ALL_LABELS' });
        }
        else if (index === 1) {
            return dispatch({ type: 'SELECT_APPLIED_LABELS' });
        }
        else {
            const category = categories[index - 2];
            if (category) {
                return dispatch({ type: 'SELECT_CATEGORY', category });
            }
        }
    }, [categories, dispatch]);
    const initialActiveIndex = react_1.default.useMemo(() => {
        var _a;
        const index = categories.indexOf((_a = props.initialCategory) !== null && _a !== void 0 ? _a : '');
        if (index > -1) {
            return index + 2;
        }
        return 0;
    }, [props.initialCategory, categories]);
    const { element: tabList } = (0, VerticalTabList_1.useVerticalTabList)({
        testId: 'category-selector',
        tabs: items,
        initialActiveIndex,
        onActiveIndexChanged,
        ariaLabel: catalog_messages_1.Messages.LabelsDialog_CategoryTitle(),
        tabClassName: categoryClass,
        overrideActiveIndex: controls.kind === 'filter',
    });
    return (react_1.default.createElement(LabelDialogStyle_1.LabelDialogBodySection, { width: 160, style: { backgroundColor: '#EBEBEB' } },
        tabList,
        react_1.default.createElement("div", { style: { height: `calc(100% - ${39 * items.length}px)`, borderRight: exports.border } })));
}
exports.LabelDialogSectionCategory = LabelDialogSectionCategory;
function ActiveLabels() {
    const state = (0, LabelsDialogContexts_1.useLabelDialogState)();
    const total = (0, catalog_core_1.filterOutNullAndUndefined)(Object.values(state.values)).flatMap(t => Object.values(t)).filter(t => t.active).length;
    return react_1.default.createElement(react_1.default.Fragment, null, catalog_messages_1.Messages.AppliedLabels({ total: catalog_messages_1.Formatters.formatCount(total) }));
}
exports.border = '1px solid #C9C9C9';
const indicator = {
    backgroundColor: '#5C5C5C',
    width: 3,
    height: '100%',
    position: 'absolute',
    content: `""`,
    left: 0,
};
const focus = {
    borderRadius: 2,
    height: `calc(100% + 3px)`,
    outlineOffset: -2,
    outline: `2px solid ${widgets_1.TabStyles.Colors.Focus}`,
};
const categoryClass = (0, vizportalclient_common_components_1.cssClass)('label-category-tab', {
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    padding: `12px 16px`,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    position: 'relative',
    borderRight: exports.border,
    $nest: {
        '&:not(:first-child)': {
            borderTop: exports.border,
        },
        '&:last-child': {
            borderBottom: exports.border,
        },
        '&:last-child::after': {
            content: `""`,
            outline: exports.border,
            height: '100%',
            display: 'block',
            position: 'absolute',
            left: '0',
        },
        '&:hover::after': indicator,
        '&:hover': {
            backgroundColor: '#C9C9C9',
        },
        '&:active::after': indicator,
        '&:active': {
            backgroundColor: '#AEAEAE',
        },
        '&:hover:enabled, &:focus': {
            backgroundColor: widgets_1.TabStyles.Colors.F3,
            color: widgets_1.TabStyles.Typography.Color.Primary,
        },
        '&:focus': focus,
        '&[aria-selected="true"]::after': indicator,
        '&[aria-selected="true"]': {
            backgroundColor: widgets_1.TabStyles.Colors.White,
            borderRight: 'none',
            boxShadow: '0 0 15px green',
            clipPath: 'inset(0px -15px 0px 0px)',
            fontWeight: 'bold',
        },
        '&[aria-selected="true"]:focus': Object.assign(Object.assign({}, focus), { outlineOffset: -3 }),
        '&[aria-selected="true"]:focus::after': Object.assign(Object.assign({}, indicator), { height: '80%', left: 4 }),
    },
});
//# sourceMappingURL=LabelsDialogSectionCategory.js.map